import React from 'react'
import { Progress, Tag } from 'antd'
import styles from './InstaController.module.scss'

function InstaControllerTitle({ response, request }) {
	return (
		<>
			{request ? (
				<div className={styles.instaHeader}>
					<span>InstaHand</span>

					<span />

					<span className={styles.instaHeaderSpan}>
						<Tag>Updating limits</Tag>
					</span>
				</div>
			) : response ? (
				<div className={styles.instaHeader}>
					<span>InstaHand</span>

					<span />

					<span className={styles.instaHeaderSpan}>
						Used:{' '}
						<Tag>
							{response.attempts} / {response.limit}
						</Tag>
					</span>
				</div>
			) : (
				<div className={styles.instaHeader}>
					<span>InstaHand</span>
				</div>
			)}
		</>
	)
}

export default React.memo(InstaControllerTitle)
